import { createAction, props } from '@ngrx/store';
import { AccessTypeSelection } from '../../../common/enums/access-type-selection.enum';
import { ClientTypes } from '../../../common/enums/client-types.enum';
import { BulkAcceptPermissionResponseDTO } from '../../../common/dtos/access-permissions.dto';

export const updateAccessTypeInGranteeFlow = createAction(
    '[Access level] Update access level for received token',
    (accessType: AccessTypeSelection) => ({ accessType }),
);

export const updateClientTypeInGranteeFlow = createAction(
    '[Client Type] Update is clientType for received token',
    (clientType: ClientTypes) => ({ clientType }),
);

export const setGranteeRegulatoryQuestions = createAction(
    '[Regulatory questions] Set regulatory question based on client selection',
    props<{ isVanguardEmployee: boolean; isAssociatedPerson: boolean; isControlPerson: boolean }>(),
);

export const setAcceptPermissionResult = createAction(
    '[Accept Permission] Set accept permission result',
    props<{ hasFullRegError: boolean }>(),
);

export const setBulkAcceptResponse = createAction(
    '[Accept Permission] Set bulk accept response',
    props<{ response: BulkAcceptPermissionResponseDTO }>(),
);

export const updateIsMultiAccountInGranteeFlow = createAction(
    '[Multi Account] Update isMultiAccount for received token',
    props<{ isMultiAccount: boolean }>(),
);
